import clsx from "clsx";
import React, { useLayoutEffect } from "react";
import { Accordion, Button, Col, Form, Row, Spinner } from "react-bootstrap";
// import PropTypes from 'prop-types';
import styles from "./styles/DiscountsTab.module.css";
// import stylesSelect from "@components/Input/styles/SelectField.module.css";
import stylesMyCourses from "@pages/InstructorCoursesPage/MyCoursesTab/styles/MyCoursesTab.module.css";
import { TableCustom } from "@components";
import { InputField } from "@components/Input/InputField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { SelectField } from "@components/Input/SelectField";
import {
  getDiscountsAction,
  createDiscountAction,
  // getMyCoursesAction,
  deleteDiscountAction,
} from "@redux/actions";
import moment from "moment";
import { ConfirmModal } from "@components/ConfirmModal/ConfirmModal";
import { FilterLayout } from "../FilterLayout/FilterLayout";
import { useExplore } from "@hooks";

const validateSchema = Yup.object().shape({
  courseId: Yup.string().required("Course is required"),

  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required")
    .when(
      "startDate",
      (startDate, yup) =>
        startDate &&
        yup.min(
          moment(startDate, "YYYY-MM-DDTHH:mm:ss").add(1, "minutes"),
          "End Date must be greater than Start Date"
        )
    ),
  discountPercent: Yup.number()
    .required("Discount amount is required")
    .min(1, "Discount amount must be greater than 0")
    .max(100, "Discount amount must be less than 100"),
});

const initialValues = {
  courseId: "",
  startDate: "",
  endDate: "",
  discountPercent: "",
};

const DiscountsTab = () => {
  const dispatch = useDispatch();
  const { discounts } = useSelector((state) => state.instructorCourse);
  const { myCourses } = useSelector((state) => state.instructorCourse);
  const { createDiscount } = useSelector((state) => state.instructorCourse);
  const { resetFilters } = useExplore();

  useLayoutEffect(() => {
    resetFilters([]);

    dispatch(getDiscountsAction());
  }, []);

  const checkDiscountValid = (item) => {
    if (moment() < moment(item.startDate).add(7, "hours")) {
      return "Pending";
    } else if (moment() > moment(item.endDate).add(7, "hours")) {
      return "Expire";
    } else {
      return "Active";
    }
  };

  const columns = [
    {
      title: "Course",
      dataIndex: "course",
      render: (course) => {
        return <p>{course.title}</p>;
        // return <p>{course}</p>;
      },
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      render: (startDate) => {
        return (
          <div>{`${moment(startDate)
            .add(7, "hours")
            .format("DD MMMM YYYY | HH:mm:ss")}`}</div>
        );
      },
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      render: (endDate) => {
        return (
          <div>{`${moment(endDate)
            .add(7, "hours")
            .format("DD MMMM YYYY | HH:mm:ss")}`}</div>
        );
      },
    },
    {
      title: "Discount",
      dataIndex: "discountPercent",
      // dataIndex: "discount",
      render: (discountPercent) => `${discountPercent}%`,
    },
    {
      title: "Price",
      dataIndex: "course",
      render: (course) => {
        return <strong>{`$${course.price}`}</strong>;
      },
    },
    {
      title: "Price Discount",
      dataIndex: "course",
      render: (course, item) => {
        return (
          <strong className={"text-danger"}>
            {`$${(course.price * (1 - item.discountPercent / 100)).toFixed(2)}`}
          </strong>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "id",
      render: (id, item) => {
        const status = checkDiscountValid(item);
        return (
          <strong
            className={clsx({
              ["text-success"]: status === "Active",
              ["text-muted"]: status === "Expire",
              ["text-warning"]: status === "Pending",
            })}
          >
            {status}
          </strong>
        );
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (status) => {
    //     return (
    //       <strong className="text-danger">
    //         {status === true ? "Active" : "Pending"}
    //       </strong>
    //     );
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id) => {
        return (
          <div>
            {/* <i
              className={clsx("bi bi-pencil-square", stylesMyCourses.icon)}
            ></i> */}
            <ConfirmModal
              onSubmit={() => {
                dispatch(deleteDiscountAction(id));
              }}
              title="Delete Course"
              submitButton="Delete"
              body="Are you sure to delete this course?"
            >
              <i className={clsx("bi bi-trash ml-2", stylesMyCourses.icon)}></i>
            </ConfirmModal>
          </div>
        );
      },
    },
  ];

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    values,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: (values) => {
      // console.log(
      //   moment(values.startDate)
      //     .subtract(7, "hours")
      //     .format("YYYY:MM:DDTHH:mm:ss")
      // );
      dispatch(
        createDiscountAction({
          data: {
            courseId: values.courseId,
            discountPercent: values.discountPercent,
            // endDate: values.endDate,
            endDate: moment(values.endDate)
              .subtract(7, "hours")
              .format("YYYY-MM-DDTHH:mm:ss")
              .toString(),
            // startDate: values.startDate,
            startDate: moment(values.startDate)
              .subtract(7, "hours")
              .format("YYYY-MM-DDTHH:mm:ss")
              .toString(),
          },
          resetFormik: () => {
            resetForm();
          },
        })
      );
      // resetForm();
    },
  });

  return (
    <div>
      <Accordion className={styles.newDiscountContainer}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>New Discount</Accordion.Header>
          <Accordion.Body>
            {/* <InputField */}
            <Form
              noValidate
              onSubmit={handleSubmit}
              className={styles.formContainer}
            >
              <Row className="g-4">
                <Col lg={5} md={6}>
                  <Form.Group className="px-0 mb-4" controlId="courseId">
                    <Form.Label>Course*</Form.Label>
                    <SelectField
                      name={"courseId"}
                      value={values.courseId || ""}
                      onChange={(val) => setFieldValue("courseId", val)}
                      listValue={myCourses.data.map((value) => {
                        return {
                          id: value.id,
                          name: value.title,
                        };
                      })}
                      isLoading={myCourses.processing}
                      placeholder={"Select Course"}
                      error={errors.courseId}
                      setFieldError={() =>
                        setFieldError("courseId", "Course is required")
                      }
                      touched={touched.courseId}
                      setFieldTouched={() => {
                        setFieldTouched("courseId", true);
                      }}
                      multiple={false}
                    />
                  </Form.Group>
                </Col>
                <Col lg={5} md={6}>
                  <Form.Group className="px-0 mb-3" controlId="discountPercent">
                    <Form.Label>Discount Amount*</Form.Label>
                    <InputField
                      name={"discountPercent"}
                      type={"number"}
                      placeholder="Percent (eg. 20 for 20%)"
                      value={values.discountPercent}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.discountPercent}
                      errorsValue={errors.discountPercent}
                    />
                  </Form.Group>
                </Col>
                <Col lg={5} md={6}>
                  <Form.Group className="px-0 mb-4" controlId="startDate">
                    <Form.Label>Start Date*</Form.Label>
                    <InputField
                      name={"startDate"}
                      type={"datetime-local"}
                      // placeholder="Select start date"
                      placeholder="dd-mm-yyyy"
                      value={values.startDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.startDate}
                      errorsValue={errors.startDate}
                    />
                  </Form.Group>
                </Col>
                <Col lg={5} md={6}>
                  <Form.Group className="px-0 mb-4" controlId="endDate">
                    <Form.Label>End Date*</Form.Label>
                    <InputField
                      name={"endDate"}
                      type={"datetime-local"}
                      placeholder="dd-mm-yyyy"
                      value={values.endDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.endDate}
                      errorsValue={errors.endDate}
                    />
                  </Form.Group>
                </Col>
                {/* <Col lg={5} md={6}>
                  <Form.Group className="px-0 mb-4" controlId="startTime">
                    <Form.Label>Start Time*</Form.Label>
                    <InputField
                      name={"startTime"}
                      type={"time"}
                      // placeholder="Select start date"
                      placeholder="hh-mm-yyyy"
                      value={values.startTime}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.startTime}
                      errorsValue={errors.startTime}
                    />
                  </Form.Group>
                </Col>
                <Col lg={5} md={6}>
                  <Form.Group className="px-0 mb-4" controlId="endTime">
                    <Form.Label>End Time*</Form.Label>
                    <InputField
                      name={"endTime"}
                      type={"time"}
                      placeholder="hh-mm-yyyy"
                      value={values.endTime}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.endTime}
                      errorsValue={errors.endTime}
                    />
                  </Form.Group>
                </Col> */}
                <Col sm={12}>
                  <Button
                    type="submit"
                    className={styles.btnSave}
                    disabled={createDiscount.processing}
                  >
                    <div className={clsx(styles.btnContent)}>
                      {createDiscount.processing ? (
                        <Spinner
                          animation="border"
                          role="status"
                          className="text-center"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      ) : null}
                      <span>Save Changes</span>
                    </div>
                  </Button>
                </Col>
              </Row>
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div className="mt-4">
        <FilterLayout
          pagination={discounts.pagination}
          hasFilter={false}
          isActive={true}
          size={1000}
          free={false}
          currentStatus={1}
          // discount={true}
        >
          <TableCustom
            columns={columns}
            dataSource={discounts.data}
            // className="mt-4"
            isLoading={discounts.processing}
          />
        </FilterLayout>
      </div>
    </div>
  );
};

/* required: display name */
DiscountsTab.displayName = "DiscountsTab";

/* required: props types */
DiscountsTab.propTypes = {};

/* required: default props */
DiscountsTab.defaultProps = {};

export { DiscountsTab };
